import { useState, type ReactNode } from 'react';
import { expandImageSources } from '../lib/calendar';

interface EventCoverProps {
  src?: string;
  className?: string;
  fallback?: ReactNode;
  children?: ReactNode;
  onAvailability?: (available: boolean) => void;
}

export function EventCover({ src, className = '', fallback, children, onAvailability }: EventCoverProps) {
  const sources = src ? expandImageSources(src) : [];
  const [index, setIndex] = useState(0);
  const current = sources[index];

  if (!current) {
    return (
      <div className={`${className} is-fallback`}>
        {fallback}
        {children}
      </div>
    );
  }

  return (
    <div className={className}>
      <img
        src={current}
        alt=""
        loading="lazy"
        onLoad={() => onAvailability?.(true)}
        onError={() => {
          const next = index + 1;
          if (next >= sources.length) onAvailability?.(false);
          setIndex(next);
        }}
      />
      {children}
    </div>
  );
}
